import React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  clickable?: boolean;
  showText?: boolean;
  invertColors?: boolean; // Invert the color logic for different backgrounds
}

const Logo: React.FC<LogoProps> = ({
  size = 'medium',
  clickable = true,
  showText = true,
  invertColors = false
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };

  const getSize = () => {
    switch (size) {
      case 'small':
        return { width: 80, height: 32 };
      case 'large':
        return { width: 160, height: 64 };
      default: // medium
        return { width: 120, height: 48 };
    }
  };

  const logoSize = getSize();

  const LogoContent = () => (
    <Box className="logo-container">
      <Box
        component="img"
        src={
          invertColors
            ? (theme.palette.mode === 'dark' ? "/COMPANY_DARKMODE_ENTIRE_LOGO.png" : "/COMPANY_LIGHTMODE_ENTIRE_LOGO.png")
            : (theme.palette.mode === 'dark' ? "/COMPANY_LIGHTMODE_ENTIRE_LOGO.png" : "/COMPANY_DARKMODE_ENTIRE_LOGO.png")
        }
        alt={`${process.env.COMPANY_NAME || 'Nautilus Dynamics'} Logo`}
        className="logo-image"
        sx={{
          width: logoSize.width,
          height: logoSize.height,
          objectFit: 'contain',
        }}
      />
      {showText && (
        <Box
          className="logo-text"
          sx={{
            display: { xs: 'none', sm: 'block' },
            fontSize: size === 'small' ? '1rem' : size === 'large' ? '1.5rem' : '1.25rem',
            fontWeight: 600,
          }}
        >
        </Box>
      )}
    </Box>
  );

  if (clickable) {
    return (
      <IconButton
        onClick={handleClick}
        sx={{
          p: 1,
          borderRadius: 2,
          '&:hover': {
            backgroundColor: 'rgba(15, 33, 52, 0.08)',
          },
        }}
        aria-label="Go to home page"
      >
        <LogoContent />
      </IconButton>
    );
  }

  return <LogoContent />;
};

export default Logo;